import '../../../../../Styles/Toyota.scss'
import React from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Image from 'react-bootstrap/Image'
import Row from 'react-bootstrap/Row'
import LoadingGif from '../../../../../static/images/loading.gif'
import AppVars from '../../../../../AppVars.js';
import { Link } from 'react-router-dom';

const appVars = AppVars.getInstance()

class CreatePasswordFormView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ...props,
        };
    }

    render() {
        return (
            <div className="justify-content-center line-box">
                <div role="banner">
                    <Row className="">
                        <Link to={appVars.getAppHomeURL(this.props.style)}><Image className="corner-logo absolute" alt="Toyota" src={require('../../../../../static/images/Toyota-Logo.svg').default} /></Link>
                    </Row>
                </div>
                <div id="submitOTPLoginAlert"
                    data-testid="OTPLoginAlert"
                    className={`${this.props.isResponseValid === false ? "error-modal" : "none"}`}
                    role="alert"
                    aria-hidden={`${this.props.isResponseValid === false ? "false" : "true"}`}
                    style={{"marginTop": "30px"}}>
                    <div className="error-modal-text">
                        The service is down. Please try again shortly.
                    </div>
                    <span onClick={this.props.hideModal} className="modal-close">&times;</span>
                </div>
                <div role="main">
                    <Row className="justify-content-center location">
                        <div>{this.props.prevStep === "RESET" ? "Password Reset":"Sign In"}</div>
                    </Row>
                    <Row className="title__TO left">Create Password</Row>
                    <Row>
                    </Row>
                    <Row className="justify-content-center message__TO left">
                        Please create a new password to continue.
                    </Row>
                    <Form id="createPasswordForm" noValidate validated={this.props.isCPFormValid} onSubmit={this.props.handleCPFormSubmit}>
                        {/* <div id="requiredDiv"><span id="required"><span id="redStar">*</span>Required</span></div> */}
                        <Form.Group id="showUsernameGroup" className="relative">
                            <Form.Label className="absolute inline-label">
                                {`${this.props.signInType === "EMAIL" ? "Email" : ""}`}
                                {`${this.props.signInType === "PHONE" ? "Mobile Number" : ""}`}
                            </Form.Label>
                            <Form.Control
                                required
                                readOnly
                                id="showUsername__TO"
                                data-testid="showUsername"
                                aria-label="Username"
                                as="input"
                                type="text"
                                name="username"
                                placeholder={this.props.displayUsername}
                                bsPrefix="readOnly form-control"
                            />
                        </Form.Group>
                        <Form.Group id="createPasswordGroupAlone" className="relative">
                            {/* NOTE: The native HTML5 validation disabled using noValidate in Form tag
                in order to disable native popup error*/}
                            <Form.Label className={`${this.props.floatPassword === true ? "absolute floating-label" : "absolute inline-label"}
                                    ${this.props.passwordFocus === true ? "label-black__TO" : ""}
                                    ${this.props.isPasswordValid === false && this.props.passwordFocus === false ? "label-red__TO" : ""}`}>
                                Password
                                <span id="redStar">*</span></Form.Label>
                            <div className="absolute show-password">
                                <img onClick={this.props.showHidePassword} src={this.props.showPassword ? require('../../../../../static/images/TO/password-hide.svg').default : require('../../../../../static/images/TO/password-show.svg').default} alt="showHide"></img>
                                <span className='show-hide'>{this.props.showPassword ? 'Hide' : 'Show'}</span>
                            </div>
                            <Form.Control
                                required
                                id="createPassword__TO"
                                data-testid="createPassword"
                                aria-label="Password"
                                as="input"
                                type={`${this.props.showPassword === false ? "password" : "text"}`}
                                name="password"
                                placeholder=""
                                value={this.props.password}
                                onChange={this.props.handlePasswordChange}
                                onFocus={this.props.setFocusPassword}
                                onBlur={this.props.onBlurPassword}
                                bsPrefix={`${this.props.isPasswordValid === false && this.props.passwordFocus === false ? "highlight-error__TO form-control" : ""}`}
                            />
                            <div
                                id="createPasswordAlert"
                                data-testid="createPasswordError"
                                className={`logon-item-error__TO ${this.props.isPasswordValid === false && this.props.passwordFocus === false ? "block" : "none"}`}
                                role="alert"
                                aria-hidden={`${this.props.isPasswordValid === false && this.props.passwordFocus === false ? "false" : "true"}`}
                            >
                                Minimum of 8 characters and a maximum of 16. Must have at least three of the following: uppercase letter, lowercase letter, number (0-9) and/or special character/symbol. Password is case-sensitive.
                            </div>
                            <div
                                id="createPasswordAlert"
                                data-testid="createPasswordError"
                                className={`logon-item-error__TO ${this.props.isPasswordUsed === true && this.props.passwordFocus === false ? "block" : "none"}`}
                                role="alert"
                                aria-hidden={`${this.props.isPasswordUsed === true && this.props.passwordFocus === false ? "false" : "true"}`}
                            >
                                Password has been used previously.
                            </div>
                        </Form.Group>
                        <div className="required required-left-grid"><span><span id="redStar">*</span>Required</span></div>
                        <div className="button-right-cp">
                            <Button data-testid="createPasswordButton" bsPrefix={`${(this.props.isPasswordValid) !== true ? "button-disabled__TO" : "button__TO "}`} type="submit" style={{ marginTop: "0px" }}>Next Step</Button>
                        </div>
                        <Image data-testid="loadingGIF" className={`working ${this.props.loading ? "" : "none"}`} id="loadingGIF" src={LoadingGif} aria-hidden="true" />
                    </Form>
                </div>
            </div>
        );
    }
}

export default CreatePasswordFormView;